export default __webpack_public_path__ + "edde184a55c7863bea62dac5249eac09.png";